"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useContainerQuery = void 0;
var mixins_1 = require("../../themes/mixins");
var react_1 = require("react");
var useContainerQuery = function (options) {
    if (options === void 0) { options = {}; }
    var enabled = options.enabled;
    var ref = (0, react_1.useRef)(null);
    var _a = (0, react_1.useState)({ width: 0, height: 0 }), containerSize = _a[0], setContainerSize = _a[1];
    (0, react_1.useEffect)(function () {
        var resizeObserver = new ResizeObserver(function (entries) {
            for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                var entry = entries_1[_i];
                var _a = entry.contentBoxSize[0], inlineSize = _a.inlineSize, blockSize = _a.blockSize;
                setContainerSize({ width: inlineSize, height: blockSize });
            }
        });
        if (ref.current) {
            resizeObserver.observe(ref.current);
        }
        return function () {
            if (ref.current) {
                resizeObserver.unobserve(ref.current);
            }
        };
    }, [ref]);
    //if container queries are written for multiple breakpoints
    //then they must be written in the order of small to big. 
    //so for example, the 'sm' query should be written before the 'md' 
    //query and so on. Else bugs will happen.
    var containerQuery = function (point) { return function (styles) {
        var breakpointWidth = (0, mixins_1.getBreakPoint)(point);
        return containerSize.width >= breakpointWidth ? styles : "";
    }; };
    return {
        ref: enabled ? ref : undefined,
        containerQuery: enabled ? containerQuery : undefined,
        containerWidth: containerSize.width,
        containerHeight: containerSize.height,
    };
};
exports.useContainerQuery = useContainerQuery;
